import * as opentherm from './opentherm';
import * as thermostat from './thermostat';
import * as ztc from './ztc';
import * as gtw from './gtw';
import * as customcontrols from './customcontrols';
import * as rf from './rf';
import * as z3k from './z3k';
const modules = [thermostat, opentherm, ztc, gtw, customcontrols, rf, z3k];
export function get_source_by_name(name) {
    for (const module of modules)
        if (module[name] != null)
            return module[name];
}
export function unserialize(config, device) {
    const source_class = get_source_by_name(config.class);
    if (device.supports_otzones_packets()) {
        let match = config.class.match(/^OTGraphSource_([a-zA-Z]+)$/);
        if (match != null) {
            if (match[1] === 'DS')
                return null;
            return new opentherm.OTZoneLineGraph(device, {
                zone_no: 0,
                ot_field: match[1].toLowerCase(),
                color: config?.params?.color,
            });
        }
        match = config.class.match(/^OT([a-zA-Z]+)FlagGraphSource$/);
        if (match != null)
            return new opentherm.OTZoneFlagGraph(device, {
                zone_no: 0,
                ot_flag: match[1].toLowerCase(),
                color: config?.params?.color,
            });
    }
    if (source_class == null) {
        console.warn('unknown graph source class:', config.class);
        return null;
    }
    const new_class = new source_class(device, config.params ?? {});
    new_class.set_color(config.params?.color);
    return new_class;
}
